import React, { useEffect, useRef } from "react";
import {
  TextField,
  Stack,
  Columns,
  Column,
  Text,
} from "@origin-digital/ods-core";
import {
  Field,
  FieldInputProps,
  FieldMetaProps,
  useFormikContext,
} from "formik";
import { FormValues } from "../types";

interface ISiteSupervisor {
  first_name?: string;
  last_name?: string;
  phone_number?: string;
  email?: string;
}

const HomeUserSiteSupervisorInternet = () => {
  const { values, setFieldValue } = useFormikContext<FormValues>();
  const hasPrefilledRef = useRef(false);

  useEffect(() => {
    if (hasPrefilledRef.current) return;

    let supervisor: ISiteSupervisor = {};

    if (
      values.internetSiteSupervisor &&
      typeof values.internetSiteSupervisor === "object"
    ) {
      supervisor = {
        first_name: values.internetSiteSupervisor.first_name,
        last_name: values.internetSiteSupervisor.last_name,
        phone_number: values.internetSiteSupervisor.phone_number,
        email: values.internetSiteSupervisor.email,
      };
    } else if (values.gasOptions && values.gasOptions.length !== 0) {
      values.gasOptions.forEach((option) => {
        if (values[option].homeUserSiteSupervisor) {
          supervisor = {
            first_name: values[option].homeUserSiteSupervisor?.firstName,
            last_name: values[option].homeUserSiteSupervisor?.lastName,
            phone_number: values[option].homeUserSiteSupervisor?.phoneNumber,
            email: values[option].homeUserSiteSupervisor?.email,
          };
        }
      });
    }

    // Only prefill if supervisor has values
    if (Object.keys(supervisor).length > 0) {
      if (supervisor.first_name) {
        setFieldValue(
          "internetSiteSupervisor.first_name",
          supervisor.first_name
        );
      }
      if (supervisor.last_name) {
        setFieldValue("internetSiteSupervisor.last_name", supervisor.last_name);
      }
      if (supervisor.phone_number) {
        setFieldValue(
          "internetSiteSupervisor.phone_number",
          supervisor.phone_number
        );
      }
      if (supervisor.email) {
        setFieldValue("internetSiteSupervisor.email", supervisor.email);
      }
      hasPrefilledRef.current = true;
    }
  }, [values.internetSiteSupervisor, values.gasOptions, setFieldValue]);

  return (
    <Stack space="large">
      <Columns
        collapseBelow="md"
        space={{ xs: "none", md: "xlarge" }}
        alignY="stretch"
      >
        <Column width="2/3">
          <Stack space="large">
            <Text weight="medium">Site supervisor</Text>
            <Stack
              space={{
                xs: "xlarge",
                md: "xxlarge",
              }}
            >
              <Columns
                collapseBelow="sm"
                space={{
                  xs: "xlarge",
                  lg: "large",
                }}
              >
                <Column>
                  <Field name="internetSiteSupervisor.first_name">
                    {({
                      field,
                      meta,
                    }: {
                      field: FieldInputProps<string>;
                      meta: FieldMetaProps<FormValues>;
                    }) => {
                      return (
                        <TextField
                          {...field}
                          id={field.name}
                          variant="outlined"
                          label="First name"
                          hideHelperTextSpace
                          error={!!meta.error}
                          helperText={meta.error}
                        />
                      );
                    }}
                  </Field>
                </Column>
                <Column>
                  <Field name="internetSiteSupervisor.last_name">
                    {({
                      field,
                      meta,
                    }: {
                      field: FieldInputProps<string>;
                      meta: FieldMetaProps<FormValues>;
                    }) => (
                      <TextField
                        {...field}
                        id={field.name}
                        variant="outlined"
                        label="Last name"
                        hideHelperTextSpace
                        error={!!meta.error}
                        helperText={meta.error}
                      />
                    )}
                  </Field>
                </Column>
              </Columns>
              <Field name="internetSiteSupervisor.phone_number">
                {({
                  field,
                  meta,
                }: {
                  field: FieldInputProps<string>;
                  meta: FieldMetaProps<FormValues>;
                }) => (
                  <TextField
                    {...field}
                    id={field.name}
                    variant="outlined"
                    label="Phone"
                    hideHelperTextSpace
                    error={!!meta.error}
                    helperText={meta.error}
                  />
                )}
              </Field>
              <Field name="internetSiteSupervisor.email">
                {({
                  field,
                  meta,
                }: {
                  field: FieldInputProps<string>;
                  meta: FieldMetaProps<FormValues>;
                }) => (
                  <TextField
                    {...field}
                    id={field.name}
                    variant="outlined"
                    label="Email"
                    hideHelperTextSpace
                    error={!!meta.error}
                    helperText={meta.error}
                  />
                )}
              </Field>
            </Stack>
          </Stack>
        </Column>
        <Column width="1/3" />
      </Columns>
    </Stack>
  );
};

export default HomeUserSiteSupervisorInternet;
